import React, { useState, useEffect, useRef, useMemo } from 'react';
import { useNavigate, useLocation } from "react-router-dom";
import { AddMedia } from '../services/mediaservice';

function MediaNew({ placeholder }) {
    
    const [name, setName] = useState("");
    const [filename, setFileName] = useState("");
    const [filetype, setFileType] = useState("");
    const [fileext, setFileExt] = useState("");
	const [alttext, setAltText] = useState("");
	const [imagecode, setImageCode] = useState("");
    const [filebase64, setFilebase64] = useState("");
    
    let navigate = useNavigate();
    
    const onFileChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            const reader = new FileReader();
            reader.onloadend = () => {
                setFilebase64(reader.result); // includes "data:*/*;base64," prefix
                const name = file.name;
                setFileName(name);
                const extension = name.substring(name.lastIndexOf(".") + 1);
                setFileExt(extension);
            };
            reader.readAsDataURL(file); // Converts file to base64 string
        }
    };
    
    const handleSave = async () => {
        const mediaBody = JSON.stringify({
            pk: 0,
            name: name,
            filename: filename,
            filetype: filetype,
            fileext: fileext,
            filebase64: filebase64,
			alttext: alttext,
			imagecode: imagecode
        });
        
        AddMedia(mediaBody);

        navigate('/media', { state: { successMessage: 'New media record added' } });
    }

    const handleCancel = async () => {
        navigate('/media/');
    }

    return (
        <>
            <div class="row">
                <div class="col-md-6 grid-margin stretch-card">
                    <div class="card">
                        <div class="card-body">
                            <h4 class="card-title">Add new Media</h4>
                            <form class="forms-sample">
                                <div class="form-group">
                                    <label for="txtName">Name</label>
                                    <input type="text" class="form-control" id="txtName" onChange={(e) => setName(e.target.value)}  placeholder="Name" />
                                </div>
                                <div class="form-group">
                                    <label for="txtFileType">File Type</label>
                                    <input type="text" class="form-control" id="txtFileType" onChange={(e) => setFileType(e.target.value)}  placeholder="File Type like Post, Author, Category" />
                                </div>
								<div class="form-group">
                                    <label for="txtAltText">Alt Text</label>
                                    <input type="text" class="form-control" id="txtAltText" onChange={(e) => setAltText(e.target.value)}  placeholder="Set alter tag here" />
                                </div>
								<div class="form-group">
                                    <label for="txtImageCode">Image Code</label>
                                    <input type="text" class="form-control" id="txtImageCode" onChange={(e) => setImageCode(e.target.value)}  placeholder="Set Image Code" />
                                </div>
                                <div class="form-group">
                                    <label for="txtMedia">Media</label>
                                    <input type="text" class="form-control" id="txtMedia" onChange={(e) => setFileName(e.target.value)} placeholder="Media" />
                                    <input type="file" class="form-control" onChange={onFileChange} />
                                </div>
                                <button type="button" class="btn btn-primary me-2" onClick={() => handleSave()}>Submit</button>
                                <button class="btn btn-light" onClick={() => handleCancel()}>Cancel</button>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default MediaNew;